/**
 * Detect eKYC outcome bells from Socket.io `notification:new` payloads.
 * Titles must stay aligned with platform `ekyc.notifications.ts` copy.
 */
export const EKYC_BELL_TITLES = [
  'Profile Review Complete',
  'Verification Completed',
  'Verification Unsuccessful',
  'Your Profile Verification is Under Review',
  'Complete eKYC to Redeem',
  'Reward Available to Redeem',
  'eKYC Failed',
  'eKYC Under Review',
] as const

function textLooksLikeEkycBell(text: string): boolean {
  const trimmed = text.trim()
  if (!trimmed) return false
  return EKYC_BELL_TITLES.some(
    (title) => trimmed === title || trimmed.startsWith(`${title}\n`),
  )
}

/**
 * True when a live bell payload is an eKYC status outcome (approve / deny / under review).
 * Generic bells persist `message` as `title\\nbody`; reward bells may also carry `title`.
 */
export function isEkycBellNotification(raw: unknown): boolean {
  if (!raw || typeof raw !== 'object') return false
  const row = raw as Record<string, unknown>

  const rawId = row.notificationId ?? row.id ?? row._id
  const id =
    typeof rawId === 'string' || typeof rawId === 'number' ? String(rawId).trim() : ''
  if (id.startsWith('bell:ekyc_result:') || id.startsWith('bell:signup_survey_')) return true

  const title = typeof row.title === 'string' ? row.title : ''
  if (textLooksLikeEkycBell(title)) return true

  const message = typeof row.message === 'string' ? row.message : ''
  if (textLooksLikeEkycBell(message)) return true

  const description = typeof row.description === 'string' ? row.description : ''
  return textLooksLikeEkycBell(description)
}
